import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { fireToastError } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import activatePricelist from '../../models/Object/activatePricelist'
import { UserObjectActions } from '../../reducers/userObject/actionNames'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { PriceGridAction } from '../../reducers/price/actionNames'

function* activate() {
  try {
    const actionNames = fetchActionsName('activate pricelist in API' as any)
    const [{ service }, userObjectId] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.select(getUserObjectId),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, activatePricelist),
      ),
    ])

    yield Effects.call(service, userObjectId)

    yield Effects.put({ type: UserObjectActions.NewPriceListActivated })
  } catch (e) {
    //console.error(e)
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

function* setScroll(action: any) {
  yield Effects.put({ type: PriceGridAction.SetScroll, payload: action.payload })
}

export default function*() {
  yield Effects.takeLatest(UserObjectActions.ActivateNewPriceList, activate)
  yield Effects.throttle(50, PriceGridAction.SetScrollThrottle, setScroll)
}
